/**
 * Register Controller
 */
(function () {

    angular.module('app.register')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['authentication', 'authenticationSettings','azureSettings', 'userRoles', '$rootScope', '$location', '$window'];
    function RegisterController(authentication, authenticationSettings, azureSettings, userRoles, $rootScope, $location, $window) {
		// get params
		var token = $location.search().registrationtoken;

        // setup model data
        var vm = this;
        vm.emailAddress = $location.search().email;
        vm.password = '';
        vm.confirmPassword = '';
        vm.securityQuestion = '';
        vm.securityAnswer = '';
        vm.confirmSecurityAnswer = '';
        vm.canRegister = false;
        vm.firstLogin = $location.search().passReset;
        vm.registering = false;
        vm.registered = false;
        vm.processing = false;

		// setup model functions
		vm.changePassword = changePassword;
		vm.register = register;
        vm.validatePassword = validatePassword;

        var applicationCacheKey = $location.search().clientId;
        if (!applicationCacheKey) {
            // use MultiPointII by default
            applicationCacheKey = authenticationSettings.defaultApplicationCacheKey;
        }

		// With the new default password changes (RSCQ2-28 & RSCQ2-31), the endpoint for canUserFinishReg isn't needed
		if(vm.firstLogin === undefined || (vm.firstLogin !== undefined && !vm.firstLogin)) {
			canUserFinishRegistration();
		}

        function canUserFinishRegistration() {
            authentication.canUserFinishRegistration(vm.emailAddress, token).then(function (response) {
                if (response === false) {
                    $window.location.href = $rootScope.redirectURL;
                }
            });
        }

        function changePassword() {
            vm.processing = true;

            var authData = JSON.parse(localStorage.getItem('cookiedata'));
            vm.emailAddress = authData.username;
            var request = {
                username: authData.username,
                token: authData.access_token,
                password: vm.password
            };
            authentication.passwordChange(request)
                .then(function (response) {

                    if (response.status === 204 || response.status === '204' || response.data === 'Password successfully updated.') {
                        if ($location.search().redirect !== undefined && $location.search().redirect !== 'undefined' && $location.search().redirect !== null) {
                            $rootScope.redirectUrl = decodeURI($location.search().redirect);
                        } else {
                            if (authData.organization_units.length > 0) {
                                var topOrg = authData.organization_units[0],
                                    roles = topOrg.applicationRoles,
                                    orgKey = topOrg.organizationUnitCacheKey,
                                    search = $location.search();

                                $rootScope.redirectURL = undefined;

                                for (var i = 0; i < roles.length; i++) {
                                    if ($rootScope.redirectURL === undefined) {
                                        switch (roles[i]) {
                                            case userRoles.MultiPointUser:
                                                $rootScope.redirectURL = authenticationSettings.multiPointUrl + '/#/' + orgKey + '/route-sheet';
                                                break;
                                            case userRoles.WelcomePointUser:
                                                $rootScope.redirectURL = authenticationSettings.welcomePointUrl + '/#/?org=' + orgKey + '&sys=WP&' + search;
                                                break;
                                            case userRoles.AppointmentsUser:
                                                break;
                                            case userRoles.CPOUser:
                                                $rootScope.redirectURL = authenticationSettings.cpoUrl + '/#/' + orgKey + '/route-sheet?' + search;
                                                break;
                                            case userRoles.ReportingUser:
                                            case userRoles.DealerReportsViewer:
                                            case userRoles.UserReportsViewer:
                                            case userRoles.InternalReportsViewer:
                                                $rootScope.redirectURL = authenticationSettings.reportingUrl + '/#/reports/' + orgKey + '?' + search;
                                                break;
                                            default:
                                                break;
                                        }
                                    }
                                }
                            }
                        }

                        vm.processing = false;
                        // If nothing else was set, set to Avenue
                        if ($rootScope.redirectUrl === undefined) {
                            $rootScope.redirectURL = authenticationSettings.avenueUrl + '/#/' + orgKey;
                        }
                        authentication.isUserRegisteredForMFA(vm.emailAddress).then(function (mfadata) {
                            if (!mfadata) {
                                $('#mfaModal').modal('show');
                            }
                            else {
                                RedirectMFALogin();
                            }
                        });
                    }
                    else {

                        vm.errorMessage = response.data;
                        vm.processing = false;
                        vm.registering = false;
                    }
                },
                    function (err) {

                        vm.errorMessage = 'Unable to reset password. Please try again.';
                        vm.processing = false;
                        vm.registering = false;
                    }
                );
        }

        function register() {
            vm.errorMessage = null;
            var request = {
                username: vm.emailAddress,
                token: token,
                password: vm.password,
                confirmPassword: vm.confirmPassword,
                question: vm.securityQuestion,
                answer: vm.securityAnswer,
                confirmAnswer: vm.confirmSecurityAnswer
            };

            vm.registering = true;
            authentication.register(request).then(function (response) {
                vm.errorMessage = null;
                vm.registered = true;
                login();
            }, function (err) {
                vm.errorMessage = 'Unable to save registration. Please try again.';
                vm.registering = false;
            });
        }
        vm.RedirectMfa = function () {
            window.open(authenticationSettings.helpdeskUrl);
        }
        vm.RedirectLogin = function () {
            RedirectMFALogin();
        }

        function RedirectMFALogin() {
            authentication.isUserExistInAzure(vm.emailAddress).then(function (data) {
                if (data != null & data != undefined & data != "") {
                    var nonce = authentication.getNonce(vm.emailAddress).then(function (nonceResponse) {
                        var tenantName = azureSettings.tenantName;
                        var policyName = azureSettings.passwordlessPolicy;
                        var clientId = azureSettings.clientId;
                        var redirectUri = azureSettings.redirectUri;
                        var nonceData = nonceResponse.data
                        var redirect = $location.search().redirect || $rootScope.redirectURL;
                        var applicationClientId = '';
                        switch (redirect.toLowerCase()) {
                            case authenticationSettings.cpoUrl.toLowerCase() + '/#/':
                            case authenticationSettings.cpoUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.cpoCacheKey;
                                break;
                            case authenticationSettings.reportingUrl.toLowerCase() + '/#/reports/':
                            case authenticationSettings.reportingUrl.toLowerCase() + '/':
                                applicationClientId = authenticationSettings.reportingCacheKey;
                                break;
                        }
                        if (applicationClientId != '') {
                            applicationCacheKey = applicationClientId;
                        }
                        var url = "https://" + tenantName + ".b2clogin.com/" + tenantName + ".onmicrosoft.com/" + policyName + "/oauth2/v2.0/authorize?response_type=code&client_id=" + clientId + "&redirect_uri=" + redirectUri + "&scope=openid&code_challenge=" + nonceData.codeChallenge + "&code_challenge_method=S256&login_hint=" + vm.emailAddress + "&nonce=" + nonceData.userNonce + "&state=" + applicationCacheKey + ";" + vm.emailAddress + ";" + nonceData.userNonce + ";" + nonceData.codeVerifier;
                        $window.location.href = url;
                    },
                        function (err) {
                            $rootScope.value = err;
                            vm.errorMessage = "MFA Validation Cancelled. Please try again.";
                        });
                }
            });
        }
        function login() {
            var request = {
                username: vm.emailAddress,
                password: vm.password,
                applicationCacheKey: authenticationSettings.defaultApplicationCacheKey
            };

            authentication.login(request).then(function (response) {
                authentication.isUserRegisteredForMFA(vm.emailAddress).then(function (mfadata) {
                    if (!mfadata) {
                        $('#mfaModal').modal('show');
                    }
                    else {
                        RedirectMFALogin();
                    }
                });
            
			}, function (err) {
				$location.path('/');
			});
		}

        function validatePassword() {
            if (vm.password === undefined) {
                return;
            }

            vm.canRegister = vm.password.replace(/\s/g, '').length !== 0;
        }
    }
})();
